export default __webpack_public_path__ + "media/images/features/toyono/sub_title_right-d9123b1e8eb920068d33347614f6f1a4.png";